import { validatePhone } from '@shared/utils';
import { useTranslation } from 'react-i18next';
import { validateCNPJ, validateCPF } from 'validations-br';
import { z } from 'zod';

export function CheckoutBuyerSchema() {
  const { t } = useTranslation('validation');

  const baseSchema = z.object({
    email: z.string().email(t('invalidEmail')),
    phone: z
      .string()
      .min(1, t('phoneRequired'))
      .refine(validatePhone, t('invalidPhone')),
    type: z.enum(['for_company', 'for_me']),
  });

  const forCompanySchema = z.object({
    type: z.literal('for_company'),
    companyName: z.string().min(1, t('companyNameRequired')),
    cnpj: z
      .string()
      .min(1, t('cnpjRequired'))
      .refine(validateCNPJ, t('invalidCNPJ')),
  });

  const forMeSchema = z.object({
    type: z.literal('for_me'),
    firstName: z.string().min(1, t('nameRequired')),
    lastName: z.string().min(1, t('lastNameRequired')),
    cpf: z
      .string()
      .min(1, t('cpfRequired'))
      .refine(validateCPF, t('invalidCPF')),
  });

  return z.discriminatedUnion('type', [
    baseSchema.merge(forCompanySchema),
    baseSchema.merge(forMeSchema),
  ]);
}

export type ICheckoutBuyerForm = z.infer<
  ReturnType<typeof CheckoutBuyerSchema>
>;
